import km from 'keymirror'
import _ from 'underscore'

export default _.extend(
  {
    // 体检订单状态 | 预约状态
    EXAMINE_ORDER_STATUS_WAIT_ORDER: 0, //未预约
    EXAMINE_ORDER_STATUS_ORDERING: 1, //预约中（待审核）
    EXAMINE_ORDER_STATUS_ORDERED: 2, //已预约
    EXAMINE_ORDER_STATUS_CHECKED: 3, //已到检
    EXAMINE_ORDER_STATUS_CANCEL: 4, //已取消
    EXAMINE_ORDER_STATUS_ERROR: 5, //预约失败
    EXAMINE_ORDER_UN_PAY: 6, // 待支付
    EXAMINE_ORDER_STATUS_ALL: 999, //全部
    // 机构列表的使用场景
    EXAMINE_LIST_SCENES_ITEM: 'item', // 商品详情
    EXAMINE_LIST_SCENES_RESERVE: 'reserve', // 预约体检
    // 预约类型
    EXMAINE_PRODUCT_RESERVE_TYPE_IS_INTERFACE: 1, //系统预约
    EXMAINE_PRODUCT_RESERVE_TYPE_IS_ARTIFICIAL: 2, //人工预约

    EXAMINE_LIST_SCENES_PREORDER: 'preorder', // 收银台
    // 预约体检时使用的证件类型
    CERTIFICATE_TYPE_IDCARD: 1, // 身份证
    CERTIFICATE_TYPE_HMT_PASS: 2, // 港澳台通行证
    CERTIFICATE_TYPE_PASSPORT: 3, // 护照
  },
  km({
    EXAMINE_ORDER_GET_ALL_EMPTY: null,
    EXAMINE_ORDER_GET_ALL_SUCCESS: null,
    EXAMINE_ORDER_GET_ALL_ERROR: null,
    EXAMINE_ORDER_GET_ALL_MORE_SUCCESS: null,

    EXAMINE_AGENCY_GET_SUCCESS: null,
    EXAMINE_AGENCY_GET_ERROR: null,

    EXAMINE_AGENCY_GET_SCHEDULE_SUCCESS: null,
    EXAMINE_AGENCY_GET_SCHEDULE_ERROR: null,
    // 预约列表
    EXAMINE_RESERVE_GET_ORDER_LIST_SUCCESS: null,
    EXAMINE_RESERVE_GET_ORDER_LIST_ERROR: null,
    // 预约详情
    EXAMINE_RESERVE_GET_ORDER_SUCCESS: null,
    EXAMINE_RESERVE_GET_ORDER_ERROR: null,

    EXAMINE_GET_EXAMINER_LIST_SUCCESS: null,

    EXAMINE_RESERVE_SET_DEFAULT_FORM_DATA: null, //预约失败的预约单初始数据
  })
)
